import { combineReducers } from 'redux';

import blockTree from './reducer/blockTree';
import infoTree from './reducer/infoTree';
import dayTree from './reducer/dayTree';
import dayList from './reducer/dayList';
import drawerInfoTree from './reducer/drawerInfoTree';
import exerciseTree from './reducer/exerciseTree';
import sessionTree from './reducer/sessionTree';
import subscribedTeamsTree from './reducer/subscribedTeamsTree';
import extraWorkTree from './reducer/extraWorkTree';
import nutrition from './reducer/nutrition';
import uiTree from './reducer/uiTree';

export default combineReducers({
    infoTree,
    blockTree,
    dayTree,
    dayList,
    drawerInfoTree,
    exerciseTree,
    extraWorkTree,
    nutrition,
    sessionTree,
    subscribedTeamsTree,
    uiTree
});



// WEBPACK FOOTER //
// ./src/state/reducer/calendar/reducer.js